export const processContent = (body) => {
    const regex = /<a data-video="(.*?)"/gm;
    let result = regex.exec(body)
    if (result !== null) {
        // make body as dom element
        let dom = document.createElement('div');
        dom.innerHTML = body;
        // find video element
        let videoElement = dom.querySelectorAll('a[data-video]');
        videoElement.forEach(element => {
            element.innerHTML = `<video class="col-lg-12" controls><source src="${element.href}" type="video/mp4"></video>`
        });
        return dom.innerHTML;
    }

    // # form
    // find form
    // get form information
    // component => [ form => inputs ]
    // ----
    // add validation to inputs
    // submit input values to server

    return body

}

export const contentSlicer = (content, slicerLength = 75) => {
    return content.slice(0, slicerLength) + (content.length > slicerLength ? "..." : "")
}